import React, { useState } from 'react';
import videoThumbnail from '../../assets/1.webp'; // Import the image

export default function VideoSection() {
  const [showComingSoon, setShowComingSoon] = useState(false);

  const handlePlayClick = () => {
    setShowComingSoon(true);
  };

  return (
    <>
      <div className="white-space-top" data-aos="fade-up">Welcome to Our Hotel</div>

      <section className="section-video">
        {!showComingSoon ? (
          <>
            <img src={videoThumbnail} alt="Hotel promotional video thumbnail" className="video-thumbnail" />
            <div className="video-overlay"></div>
            <div className="video-inner">
              <div className="stars" style={{ color: '#C0B283' }} data-aos="fade-up">★★★★★</div>
              <h1 className="title" data-aos="fade-up">Hotel Promotional Video</h1>
              <button onClick={handlePlayClick} data-aos="zoom-in" className="play-btn hover:scale-[1.1] transition">
                <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
              </button>
            </div>
          </>
        ) : (
          <>
            <img src={videoThumbnail} alt="Hotel promotional video thumbnail" className="video-thumbnail" />
            <div className="video-overlay"></div>
            <div className="video-inner flex items-center justify-center">
              <div className="text-center">
                <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-wide">Hotel Promotional Video</h2>
                <p className="text-2xl md:text-3xl text-white font-semibold">Coming Soon</p>
                <p className="text-lg text-gray-300 mt-2">We are working hard to bring you an amazing experience!</p>
              </div>
            </div>
          </>
        )}
      </section>

      <div className="white-space-bottom" data-aos="fade-up">Experience Comfort & Elegance</div>
    </>
  );
}